import script from "./SiteSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiteSearch.vue?vue&type=script&lang=ts&setup=true"

import "./SiteSearch.vue?vue&type=style&index=0&id=64ce84f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ce84f8"]])

export default __exports__